import { projects } from '@/mocks/projects';

const projectRouteIds: Record<string, string> = {
  '/portfolio/mitcham-townhouse-subdivision': 'mitcham',
  '/portfolio/ringwood-terrace-townhouses': 'ringwood',
  '/portfolio/toorak-luxury-residence': 'toorak-luxury',
  '/portfolio/carlton-cafe-patisserie': 'carlton',
  '/portfolio/yering-hotel': 'yerring',
};

export const getProjectPage = (pathname: string) => {
  const id = projectRouteIds[pathname];
  return projects.find((project) => project.id === id);
};

export const projectPathById = Object.fromEntries(
  Object.entries(projectRouteIds).map(([path, id]) => [id, path]),
);
